import { FilePresenter } from '@/forms/components/presenters/FilePresenter';
import { FormFieldType, type FileFormField } from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildFileInitialState } from './initialState';

export const fileFieldModule: FormFieldModule = {
  type: FormFieldType.File,
  Presenter: ({ field, disabled }) => (
    <FilePresenter field={field as FileFormField} disabled={disabled} />
  ),
  flattenLeaves: field => [field as FileFormField],
  buildInitialState: buildFileInitialState,
};
